import $ from 'jquery';
import _ from 'underscore';
import Cache from 'root/cache';
import Util from 'root/module/util';
import Modals from 'root/modals';
import View from 'view/base';
import View_Feedback_Video_Player from 'view/feedback_viewer/video_player';

export default View.extend({
    className: 'portal-feedback-preview',

    mode: 'preview', // preview, desc, roadmap

    screenshot_height_preview: 86,
    screenshot_height: 140,

    vote_count: 0,

    dispatcher: _.extend({}, Backbone.Events),

    views: {
        video_player: {}
    },

    events: {
        'click'                     : 'onOpen',
        'click .vote'               : 'onVote',
        'click .unvote'             : 'onVote',
        'click .expand'             : 'onExpandImage',
        'click .video-play'         : 'onPlayVideo'
    },

    dom_handlers: {
        onOpen: function(e) {
            if (this.mode === 'desc') {
                return;
            }

            if ($(e.target).hasClass('navigation')) {
                return;
            }

            Cache.app.dispatcher.trigger('Portal::Feedback::View', {
                model: this.model
            });
        },

        onVote: function(e) {
            e.stopPropagation();

            if ($(e.target).hasClass('unvote')) {
                return;
            }

            if (this.vote_count > 10) {
                clearTimeout(this.vote_timeout);
                this.vote_timeout = setTimeout(function() {
                    this.vote_count = 0;
                }, 5000);

                return;
            }

            this.vote();
            this.vote_count++;
        },

        onExpandImage: function(e) {
            var container = $(e.currentTarget).parent();
            container.toggleClass('expanded');

            if ($(e.currentTarget).data('type') !== 'screenshot') {
                return;
            }

            if (container.hasClass('expanded')) {
                container.children('img').css({
                    width  : '100%',
                    height : 'auto'
                });
            } else {
                container.children('img').css({
                    width  : '',
                    height : this.screenshot_height
                });
            }

            var zoom = container.find('img').width() / container.data('width');
            container.data('zoom', zoom);

            this.renderPinComments();
        },

        onPlayVideo: function(e) {
            if (this.mode !== 'desc') {
                return;
            }

            var container = $(e.currentTarget).parent();
            Modals.previewVideo(container.find('video').attr('src'));
        }
    },

    event_handlers: {
        onVoteChange: function(model) {
            this.$el.find('.vote').text(model.getVoteCount());
        }
    },

    initialize: function(options) {
        this.views = {
            video_player: {}
        };

        this.mode = options.mode;

        if (this.model.get('video_url') && this.mode === 'desc') {
            this.views.video_player = new View_Feedback_Video_Player({
                model      : this.model,
                dispatcher : this.dispatcher,
                readonly   : true
            });
        }

        this.listenTo(this.model, 'change:workflow',   this.renderStats);
        this.listenTo(this.model, 'change:category',   this.renderStats);
        this.listenTo(this.model, 'change:vote_count', this.event_handlers.onVoteChange);
        this.listenTo(this.model, 'change:is_pinned',  this.render);
    },

    renderPinComments: function() {
        if (this.mode === 'roadmap') {
            return;
        }

        this.$el.find('.feedback-screenshot .pin').each(function() {
            var comment_id = parseInt($(this).data('id'), 10);
            var comment_model = Cache.feedback_comment.get(comment_id);

            if (comment_model) {
                var zoom = $(this).parent().data('zoom');

                $(this).css({
                    top  : comment_model.get('screen_y') * zoom,
                    left : comment_model.get('screen_x') * zoom
                }).show();
            }
        });
    },

    vote: function() {
        if (!Cache.real_user_id && !Cache.portal_user && !Cache.guest_user) {
            Modals.portalGuest();
            return;
        }

        Cache.app.request({
            action: 'feedback/vote',
            data: {
                feedback_id: this.model.id
            },
            context: this,
            success: function(response) {
                this.model.set('vote_count', response.vote_count);

                if (response.vote_action === 'up') {
                    this.$el.find('.vote').addClass('animating voted');

                    setTimeout(() => {
                        this.$el.find('.vote').removeClass('animating');
                    }, 1000);
                } else {
                    this.$el.find('.vote').removeClass('voted')
                }
            }
        });
    },

    renderStats: function() {
        var workflow_model = Cache.workflow.get(this.model.get('workflow'));
        var status_model   = workflow_model ? Cache.portal_status.get(workflow_model.get('portal_status_id')) : null;
        var status_colour  = status_model ? status_model.get('colour') : '';
        var categories     = '';

        // categories
        if (this.model.get('category')) {
            this.model.get('category').split(',').forEach(function(category_name) {
                if (Cache.feedback_category.findWhere({name: category_name})) {
                    var href = (window.location.search ? window.location.search + '&' : '?') + 'categories=' + Util.htmlEntities(category_name);

                    categories += '<a class="navigation" href="' + href + '">#' + Util.htmlEntities(category_name) + '</a>';
                }
            }.bind(this));
        }

        var content =
        (status_model && this.mode !== 'roadmap' ?
        '<div class="feedback-status" style="border-color:' + Util.hexToRgba(status_colour, 0.4) +  ';color:' + status_colour + ';background-color:' + Util.hexToRgba(status_colour, 0.04) + ';">' + status_model.escape('status_name') + '</div>' : '') +

        (categories ?
        '<div class="feedback-tags">' + categories + '</div>' : '') +

        (this.mode === 'preview' || this.mode === 'roadmap' ?
        '<div class="comment-count">' + this.model.getTotalComments(true) + '</div>' : '');

        this.$el.find('.feedback-stats').html(content);
    },

    render: function() {
        var all_workflows = Cache.workflow.sortBy('sort').map((item) => item.id);
        var shipped_workflow = _.last(all_workflows);
        var current_workflow = this.model.get('workflow');
        var shipped = current_workflow === shipped_workflow;

        var screenshots = Cache.feedback_screenshot.where({feedback_id: this.model.id});
        var screenshot_images = '';

        // screenshot images
        screenshots.forEach(function(model, index) {
            if (this.mode === 'roadmap') {
                // only need the first one
                if (index > 0) {
                    return;
                }

                screenshot_images +=
                '<div>' +
                    '<img src="' + model.get('url') + '">' +
                    (screenshots.length > 1 ?
                    '<div class="count">+' + (screenshots.length - 1) + '</div>' : '') +
                '</div>';
            } else {
                var height = this.mode === 'desc' ? this.screenshot_height : this.screenshot_height_preview;
                var zoom   = height / model.get('window_y');
                var width  = zoom * model.get('window_x');

                screenshot_images +=
                '<div data-zoom="' + zoom + '" data-width="' + model.get('window_x') + '" data-height="' + model.get('window_y') + '">' +
                    '<img src="' + model.get('url') + '" style="height:' + height + 'px;">' +
                    (this.mode === 'desc' ?
                    '<div class="expand" data-type="screenshot"></div>' : '');

                    Cache.feedback_comment.where({feedback_id: this.model.id, screenshot_num: index}).forEach(function(comment_model) {
                        if (comment_model.get('screen_number') > 0) {
                            screenshot_images += '<div class="pin" data-id="' + comment_model.id + '">' + comment_model.get('screen_number') + '</div>';
                        }
                    });

                screenshot_images +=
                '</div>';
            }
        }.bind(this));

        if (this.model.get('attachment') && Util.isImage(this.model.get('attachment'))) {
            screenshot_images +=
            '<div>' +
                '<img src="' + this.model.get('attachment') + '">' +
                (this.mode === 'desc' ?
                '<div class="expand" data-type="image"></div>' : '') +
            '</div>';
        }

        // comments
        var title = this.model.get('title') || 'Untitled';

        var content = '';

        if (this.mode === 'roadmap') {
            content +=
                (screenshot_images ?
                '<div class="feedback-screenshot">' + screenshot_images + '</div>' : '') +

                (this.model.get('video_url') ?
                '<div class="feedback-screenshot">' +
                    '<div>' +
                        '<video src="' + this.model.get('video_url') + '" muted></video>' +
                        '<div class="video-play"></div>' +
                    '</div>' +
                '</div>' : '');

        }

        content += '<div class="content-grid">';

        content += '<div class="' + (shipped ? 'unvote' : 'vote') + (this.model.get('voted') ? ' voted' : '') + '">' + this.model.getVoteCount() + '</div>';

        content += '<div class="feedback-details">' +
                        '<div>' +

                        (this.mode === 'desc' ?

                        '<div class="author-details">' +
                            '<div>' +
                                '<div class="user-img-32" style="background-image:url(' + this.model.getReporterAvatar() + ');"></div>' +
                            '</div>' +
                            '<div>' +
                                '<div class="name">' + Util.htmlEntities(this.model.getReporterName()) + '</div>' +
                                '<div class="date">' + Util.moment(this.model.get('time')) + '</div>' +
                            '</div>' +
                        '</div>' : '') +

                        '<h3>' +
                            (this.mode === 'preview' && this.model.get('is_pinned') ? '<span class="pin-mark"><i class="fa-solid fa-thumbtack"></i> Pinned</span>' : '') +
                            (this.mode === 'desc'    && this.model.get('is_pinned') ? '<span class="pin-mark-inline"><i class="fa-solid fa-thumbtack"></i> Pinned</span>' : '') +
                            (this.mode === 'roadmap' && this.model.get('is_pinned') ? '<span class="pin-mark-roadmap"><i class="fa-solid fa-thumbtack"></i> Pinned</span>' : '') +
                            (this.mode === 'roadmap' ? Util.htmlEntities(Util.trim(title, 120)) : Util.htmlEntities(title)) +
                        '</h3>' +

                        (this.mode === 'roadmap' ? '' :
                        '<div class="feedback-description">' +
                        (this.mode === 'preview' ?
                            Util.trim(this.model.escape('description'), 220) :
                            Util.urlify(Util.nl2br(this.model.escape('description')))
                        ) +
                        '</div>') +

                        '<div class="feedback-stats"></div>' +

                        (this.mode === 'roadmap' ? '' :

                        (screenshot_images ?
                        '<div class="feedback-screenshot">' + screenshot_images + '</div>' : '') +

                        (this.model.get('video_url') ?
                        (this.mode === 'desc' ?
                        '<div class="region-video-player"></div>' :
                        '<div class="feedback-screenshot">' +
                            '<div>' +
                                '<video src="' + this.model.get('video_url') + '" muted></video>' +
                                '<div class="video-play"></div>' +
                                (this.mode === 'desc' ?
                                '<div class="expand" data-type="video"></div>' : '') +
                            '</div>' +
                        '</div>') : '')

                        ) +

                        (this.mode === 'desc' && this.model.get('attachment') && !Util.isImage(this.model.get('attachment')) ?
                        '<div class="feedback-attachment">' +
                            '<a href="' + this.model.get('attachment') + '" target="download">' +
                                '<i class="far fa-paperclip margin-right-4"></i>' +
                                Util.baseName(this.model.get('attachment')) +
                            '</a>' +
                        '</div>' : '') +

                        '</div>' +
                    '</div>' +
                '</div>';

        this.$el.html(content);

        this.$el.attr('data-mode', this.mode);

        this.renderStats();
        this.renderPinComments();

        if (this.model.get('video_url') && this.mode === 'desc') {
            this.views.video_player.render().$el.appendTo(this.$el.find('.region-video-player'));
        }

        if (this.model.get('is_pinned')) {
            this.$el.attr('data-pinned', 1);
        } else {
            this.$el.removeAttr('data-pinned');
        }

        return this;
    }
});